import React, { useState, useEffect, forwardRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { InputText } from "primereact/inputtext";
// import StakeholderPopup from "./StakeholderPopup";
import { FilterMatchMode } from "primereact/api";

function DataTables(props, ref) {
	const [products, setProducts] = useState([]);
	const [selectedProduct, setSelectedProduct] = useState(props.value);
	const [lazyLoading, setLazyLoading] = useState(false);
	const [globalFilterValue, setGlobalFilterValue] = useState("");
	const [filters, setFilters] = useState({
		global: { value: null, matchMode: FilterMatchMode.CONTAINS },
	});
	const [values, setValues] = useState(props.value);
	const [selectedItems, setSelectedItems] = useState([]);
	let loadLazyTimeout = null;

	const onGlobalFilterChange = (e) => {
		const value = e.target.value;
		let _filters = { ...filters };
		_filters["global"].value = value;
		setFilters(_filters);
		setGlobalFilterValue(value);
	};

	const loadCarsLazy = () => {
		!lazyLoading && setLazyLoading(true);
		if (loadLazyTimeout) {
			clearTimeout(loadLazyTimeout);
		}
		loadLazyTimeout = setTimeout(() => {
			setLazyLoading(false);
		}, 100);
		setProducts(props.value);
	};

	const handleSelectionChange = (e) => {
		const selectedProducts = e.value;
		setSelectedItems(selectedProducts); 
		
		values.forEach(item => {
			item.template_checked = selectedProducts.some(selected => 
				selected._id === item._id 
			);
		});
		const indices = selectedProducts.map((selectedProduct) => {
			const product = values?.find(
				(product) => product._id === selectedProduct._id 
			);
			return product ? product.field_index : undefined;
		}).filter(index => index !== undefined);
		
		if (props.removeField) {
			props.removeField(indices, selectedProducts);
		}
	};

	useEffect(() => {
		if (props?.deleted) {
			setSelectedProduct([])
		}
		if(props?.cloned){
			setSelectedProduct([])
		}
	}, [props?.deleted,props?.cloned])

	const handleSelection = (e) => {
		setSelectedProduct(e.value);
		if (props.rowClick) {
			props.rowClick(e.value);
		}
		if (props.getCollectionTemplate) {
			props.getCollectionTemplate(e.value);
		}
		if (props.removeField) {
			// Finding the indices of the selected products in the products array
			const indices = e.value.map((selectedProduct) => {
				// Find the product based on the conditions
				const product = products?.find(
					(product) => product._id === selectedProduct._id
				);
				// Return the field_index if the product is found; otherwise, return undefined
				return product ? product.field_index : undefined;
			});

			// Call the prop function with the indices and selected items
			props.removeField(indices, e.value);
		}
	};

	const handlePromptSelection = (e) => {
		setSelectedProduct(e.value);
		if (props.removeField) {
			// Finding the indices of the selected products in the products array
			const indices = e.value.map((selectedProduct) => {
				// Find the product based on the conditions
				const product = products?.find(
					(product) => product._id === selectedProduct._id
				);
				// Return the field_index if the product is found; otherwise, return undefined
				return product ? product.field_index : undefined;
			});

			// Call the prop function with the indices and selected items
			props.removeField(indices, e.value);
		}
	};

	const handleRowClick = (e) => {
		if (props.rowClick) {
			props.rowClick(e.data);
		}
	};

	const handleRowEditComplete = (e) => {
		props.rowEditClick(e.newData);
	}

	const handleReOrderClick = (e) => {
		props.reorderClick(e.value);
	};

	const dynamicColumns = props.columns.map((col) => {
		return col.field ? (
			col.field === "expander" ? (
				<Column
					expander
					field={col.field}
					className="width-025"
					headerClassName={col.headerClassName}
				></Column>
			) : (
				<Column
					key={col.field}
					field={col.field}
					editable="false"
					header={col.header}
					body={col.body}
					sortable={col.sortable}
					style={col.style}
					headerClassName={col.headerClassName}
					filter={col.showFilter}
					filterMatchMode="contains"
					showFilterMatchModes={false}
					showApplyButton={false}
					editor={col.editor}
					className={col.className ? col.className : "datatable-column-style"}
				/>
			)
		) : (
			<Column
				key={col.field}
				className={col.field}
				field={col.field}
				header={col.header}
				colSpan={col.colSpan}
				body={col.header}
				selectionMode={"multiple"}
				style={{ width: "40%" }}
				onRowClick={handleRowClick}
				sortable
			/>
		);
	});

	useEffect(() => {
		loadCarsLazy();
	}, []);

	const renderHeader = () => {
		if (props.header) {
			return (
				<>
					<div className="p-grid m-0 align-center justify-between pt-10">
						<div className="d-flex ">
							{props.search && (
								<div className="table-header">
									<span className="p-input-icon-left">
										<i className="pi pi-search" />
										<InputText
											value={globalFilterValue}
											onChange={onGlobalFilterChange}
											type="search"
											placeholder={props.placeholder}
											className="fs-12"
										/>
									</span>
								</div>
							)}
						</div>
					</div>
				</>
			);
		}
	};

	const header = () => {
		if (props.header && props.headerName) {
			return <span>{props.headingName}</span>;
		} else if (props.header) {
			return <span>Ability</span>;
		}
	};

	const renderHeaderExpand = () => {
		if (props.header) {
			return <span>{props.clientKnownHeading}</span>;
		}
	};

	return (
		<>
			{props.isAttachment && (
				<DataTable
					value={props.value}
					height={"100px"}
					// cellSelection
					// pagination
					lazy
					first={props?.lazyParams?.first}
					totalRecords={props?.totalRecords}
					onPage={props?.onPage}
					// paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					// onRowsPerPageChange={props?.onRowsPerPageChange}
					// pagination ends
					dragSelection
					// tableStyle={{ minWidth: "50rem" }}
					// virtualScrollerOptions={{
					//     lazy: true, onLazyLoad: loadCarsLazy,
					//     itemSize: 18, delay: 50, showLoader: true, loading: lazyLoading,
					//     loadingTemplate
					// }}
					rows={props?.lazyParams?.rows || 50}
					selectionMode="single" // Set selectionMode to checkbox
					rowsPerPageOptions={[10, 20, 30, 50]}
					// size={"small"}
					selection={selectedProduct}
					onSelectionChange={(e) => setSelectedProduct(e.value)}
					// onSelectionChange={handleSelectionChange}
					currentPageReportTemplate="{first} to {last} of {totalRecords}"
					paginatorLeft={props.paginatorLeft}
					paginatorRight={props.paginatorRight}
					scrollable
					scrollHeight="300px"
					onRowClick={handleRowClick} // Handle row clicks separately
					dataKey={props.dataKey}
				>
					{!props?.isAttachment ? (
						<Column
							selectionMode="multiple"
							headerStyle={{ width: "1.5rem" }}
						></Column>
					) : (
						<Column headerStyle={{ width: "1.5rem" }}></Column>
					)}
					{dynamicColumns}
				</DataTable>
			)}
			{props.isDataCollectionConfig && (
				//dede
				<DataTable
					value={values}
					selection={selectedItems}
					cellSelection
					paginator
					rows={10}
					selectionMode="checkbox" // Ensure this is set to "checkbox"
					rowsPerPageOptions={[10, 20, 30, 50]}
					size={"small"}
					// selection={values?.filter((item) => item.template_checked)}
					onSelectionChange={handleSelectionChange}
					currentPageReportTemplate="{first} to {last} of {totalRecords}"
					scrollable
					scrollHeight="300px"
					dataKey={props.dataKey}
					// onRowClick={handleRowClick}
				>
					<Column
						selectionMode="multiple"
						headerStyle={{ width: "1.5rem" }}
					></Column>
					{dynamicColumns}
				</DataTable>
			)}
			{props.isPermissions && (
				<DataTable
					value={props.value}
					dataKey={props.dataKey}
					paginator
					rows={props?.lazyParams?.rows || 10}
					rowsPerPageOptions={[5, 10, 25, 50]}
					onRowClick={handleRowClick}
					header={header}
				>
					{dynamicColumns}
				</DataTable>
			)}

			{
				props.isRowEditor && (
					<DataTable
						value={props.value}
						dataKey={props.dataKey}
						onRowEditComplete={handleRowEditComplete}
						editMode="row"
					>
						{dynamicColumns}
						<Column
							rowEditor
							headerStyle={{ width: "1.5rem" }}
							headerClassName="header-datatable"
							className="row-datatable"
						></Column>
					</DataTable>
				)
			}
			{
				props.isRowEditorPage && (
					<DataTable
						value={props.value}
						dataKey={props.dataKey}
						onRowEditComplete={handleRowEditComplete}
						editMode="row"
						paginator
						rows={props?.lazyParams?.rows || 10}
						rowsPerPageOptions={[5, 10, 25, 50]}
						lazy
						first={props?.lazyParams?.first}
						totalRecords={props?.totalRecords}
						onPage={props?.onPage}
						header={header}
					>
						{dynamicColumns}
						<Column
							rowEditor
							headerStyle={{ width: "1.5rem" }}
							headerClassName="header-datatable"
							className="row-datatable"
						></Column>
					</DataTable>
				)
			}
			{
				props.isRowEditorUserClass && (
					<DataTable
						value={props.value}
						dataKey={props.dataKey}
						onRowEditComplete={handleRowEditComplete}
						editMode="row"
						paginator
						rows={props?.lazyParams?.rows || 10}
						rowsPerPageOptions={[5, 10, 25, 50]}
						header={props.header}
					>
						{dynamicColumns}
						<Column
							rowEditor
							headerStyle={{ width: "1.5rem" }}
							headerClassName="header-datatable"
							className="row-datatable"
						></Column>
					</DataTable>
				)
			}
			{props.isNotReorder && (
				<DataTable
					value={props.value}
					selectionMode="checkbox" // Set selectionMode to checkbox
					selection={selectedProduct}
					onSelectionChange={handleSelection}
					dataKey={props.dataKey}
					onRowClick={handleRowClick}
					paginator
					rows={props?.lazyParams?.rows || 10}
					rowsPerPageOptions={[5, 10, 25, 50]}
					resizableColumns
					columnResizeMode="expand"
				>
					<Column
						selectionMode="multiple"
						headerStyle={{ width: "1.5rem" }}
						headerClassName="header-datatable"
						className="row-datatable"
					></Column>
					{dynamicColumns}
				</DataTable>
			)}
			{props.gatewaypermissions && !props.isCheckbox &&  (
				<DataTable
					value={props.value}
					onSelectionChange={handleSelection}
					dataKey={props.dataKey}
					onRowClick={handleRowClick}
					paginator
					rows={props?.lazyParams?.rows || 10}
					rowsPerPageOptions={[5, 10, 25, 50]}
					resizableColumns
					columnResizeMode="expand"
				>

					{dynamicColumns}
				</DataTable>
			)}
			{props.isNewField && !props.isCheckbox && (
				<DataTable
					value={props.value}
					selection={selectedProduct}
					onSelectionChange={handleSelection}
					dataKey={props.dataKey}
					onRowClick={handleRowClick}
					editMode={props.editMode}
				>
					{dynamicColumns}
				</DataTable>
			)}
			{props.isCheckbox && !props.isNewField && (
				<DataTable
					value={props.value}
					selectionMode="checkbox" // Set selectionMode to checkbox
					selection={selectedProduct}
					onSelectionChange={handleSelection}
					dataKey={props.dataKey}
					onRowClick={handleRowClick}
					paginator
					rows={props?.lazyParams?.rows || 10}
					rowsPerPageOptions={[5, 10, 25, 50]}
					reorderableColumns
					reorderableRows
					onRowReorder={handleReOrderClick}
				>
					<Column
						selectionMode="multiple"
						headerStyle={{ width: "1.5rem" }}
						headerClassName="header-datatable"
						className="row-datatable"
					></Column>
					<Column
						rowReorder
						headerClassName="header-datatable"
						className="row-datatable width-3"
					/>
					{dynamicColumns}
				</DataTable>
			)}
			{props.isPrompts && (
				<DataTable
					value={props.value}
					selectionMode="checkbox" // Set selectionMode to checkbox
					selection={selectedProduct}
					onSelectionChange={handlePromptSelection}
					dataKey={props.dataKey}
					onRowClick={handleRowClick}
					paginator
					rows={props?.lazyParams?.rows || 10}
					rowsPerPageOptions={[5, 10, 25, 50]}
					lazy
					first={props?.lazyParams?.first}
					totalRecords={props?.totalRecords}
					onPage={props?.onPage}
					resizableColumns
					columnResizeMode="expand"
					sortField={props?.lazyParams.sortField} 
					sortOrder={props?.lazyParams.sortOrder} 
					onSort={props?.onSort} 
					
				>
					<Column
						selectionMode="multiple"
						headerStyle={{ width: "1.5rem" }}
						headerClassName="header-datatable"
						className="row-datatable"
					></Column>
					{dynamicColumns}
				</DataTable>
			)}
			{props.usageLog && !props.isCheckbox && (
				<DataTable
					value={props.value}
					dataKey={props.dataKey}
					paginator
					rows={props?.lazyParams?.rows || 10}
					rowsPerPageOptions={[5, 10, 25, 50]}
					onRowClick={handleRowClick}
					editMode={props.editMode}
					lazy
					first={props?.lazyParams?.first}
					totalRecords={props?.totalRecords}
					onPage={props?.onPage}
					resizableColumns
					columnResizeMode="expand"
					sortField={props?.lazyParams.sortField} 
					sortOrder={props?.lazyParams.sortOrder} 
					onSort={props?.onSort} 
				>

					{dynamicColumns}
				</DataTable>
			)}
			{props.dataSubmitted && (
				<DataTable value={props.value} header={header} paginator={props.paginator} rows={10} rowsPerPageOptions={[5, 10, 25, 50]} filters={filters}>
					{dynamicColumns}
				</DataTable>
			)}
			{!props.isAttachment &&
				!props.isDataCollectionConfig &&
				!props.dataSubmitted &&
				!props.isCheckbox &&
				!props.isNewField &&
				!props.isPrompts &&
				!props.isNotReorder && !props.isRowEditor && !props.isRowEditorPage && !props.isRowEditorUserClass && !props.usageLog && !props.isPermissions && !props.gatewaypermissions && (
					<DataTable
						value={props.value}
						cellSelection
						// pagination
						lazy
						first={props?.lazyParams?.first}
						totalRecords={props?.totalRecords}
						onPage={props?.onPage}
						// paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
						// onRowsPerPageChange={props?.onRowsPerPageChange}
						// pagination ends
						dragSelection
						// tableStyle={{ minWidth: "50rem" }}
						// virtualScrollerOptions={{
						//     lazy: true, onLazyLoad: loadCarsLazy,
						//     itemSize: 18, delay: 50, showLoader: true, loading: lazyLoading,
						//     loadingTemplate
						// }}
						paginator
						rows={props?.lazyParams?.rows || 50}
						selectionMode="checkbox" // Set selectionMode to checkbox
						rowsPerPageOptions={[10, 20, 30, 50]}
						size={"small"}
						selection={selectedProduct}
						// onSelectionChange={(e) => setSelectedProduct(e.value)}
						onSelectionChange={handleSelectionChange}
						currentPageReportTemplate="{first} to {last} of {totalRecords}"
						paginatorLeft={props.paginatorLeft}
						paginatorRight={props.paginatorRight}
						scrollable
						scrollHeight="300px"
						onRowClick={handleRowClick} // Handle row clicks separately
					>
						{!props?.isAttachment ? (
							<Column
								selectionMode="multiple"
								headerStyle={{ width: "1.5rem" }}
							></Column>
						) : (
							<Column headerStyle={{ width: "1.5rem" }}></Column>
						)}
						{dynamicColumns}
					</DataTable>
				)}
		</>
	);
}

export default forwardRef(DataTables);
